module.exports = __webpack_public_path__ + "assets/icons/big-home.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/building/big-home.png
// module id = ./src/styles/icons/building/big-home.png
// module chunks = 0